// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { SpinTokens } from './type';

const spinTokens: SpinTokens = {
  spinTipFontColor: 'Brand-6',
  spinTipFontSize: 'Font-14',
  spinVerticalMargin: 'Spacing-4',
  spinHorizontalMargin: 'Spacing-4',
  spinColor: 'Brand-6',
  spinBackgroundColor: 'Neutral-fill-1',
};

export default spinTokens;
